import React from 'react';
import EncabezadoVista from './vista/encabezadoVista';

const Encabezado: React.FunctionComponent = () => (<EncabezadoVista/>);

export default Encabezado;
